import React, { Component } from "react";
import { connect } from "react-redux";
import Fade from "react-reveal/Fade";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { SideMenuQuery } from "../../constants/apiParams";
import apiCall, { METHOD } from "../../constants/baseUrl";
import * as actions from "../../constants/mapDispatchToProps";
import * as stateToProps from "../../constants/mapStateToProps";
import SideMenuItem from "./SideMenuItem";

class TopHeader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      menuStatus: false,
      side_menu_list: [],
      isLoading: false
    };
  }

  openMenu = () => {
    this.setState(() => {
      return {
        ...this.state,
        menuStatus: true
      };
    });
  };

  closeMenu = () => {
    this.setState(() => {
      return {
        ...this.state,
        menuStatus: false
      };
    });
  };

  handleAfterApiCall = data => {
    this.props.getSideMenuList(data);
    this.setState(() => {
      return {
        ...this.state,
        side_menu_list: data.side_menu_list
      };
    });
  };

  handleLoader = status => {
    this.setState(() => {
      return {
        ...this.state,
        isLoading: status
      };
    });
  };

  componentDidMount() {
    if (!this.props.sideMenu.side_menu_list) {
      apiCall(
        METHOD.QUERY,
        SideMenuQuery(),
        data => this.handleAfterApiCall(data),
        isLoading => this.handleLoader(isLoading),
      (data) => {
        toast.error(this.props.t(data.message));
      }
      );
    }
  }

  render() {
    const { menuStatus } = this.state;
    const { side_menu_list } =
      this.props.sideMenu && this.props.sideMenu;
    return (
      <React.Fragment>
        <nav className="navbar navbar-dark ">
          <button
            className="navbar-toggler collapsed"
            type="button"
            data-toggle="collapse"
            data-target="#navbarsExample01"
            aria-controls="navbarsExample01"
            aria-expanded="false"
            aria-label="Toggle navigation"
            onClick={this.openMenu}
          >
            <span className="navbar-toggler-icon "></span>
          </button>
          <Fade left when={menuStatus}>
            <div
              className={
                menuStatus ? "navbar-collapse show" : "navbar-collapse collapse"
              }
              id="navbarsExample01"
            >
              <button
                className="navbar-toggler icon-close collapsed ml-3 mt-3"
                type="button"
                data-toggle="collapse"
                data-target="#navbarsExample01"
                aria-controls="navbarsExample01"
                aria-expanded="false"
                onClick={this.closeMenu}
                aria-label="Toggle navigation"
              >
                <i className="zmdi zmdi-close zmdi-hc-fw font-30"></i>
              </button>
              <ul className="navbar-nav mr-auto">
                <li className="text-center mb-4">
                  <Link to="/home">
                    <img
                      src="/images/logo.png"
                      alt="ico"
                      style={{ width: "150px" }}
                    />
                  </Link>
                </li>

                {side_menu_list &&
                  side_menu_list.map((item, index) => {
                    return <SideMenuItem {...item} key={index} />;
                  })}
              </ul>
            </div>
          </Fade>
        </nav>
      </React.Fragment>
    );
  }
}
export default connect(
  state =>
    stateToProps.appMapStateToProps(
      [stateToProps.sideMenuStateToProps],
      state
    ),
  actions.appMapDispatchToProps([actions.sideMenuDispatchToProps])
)(TopHeader);
